<template>
  <div>
    <div class="level" style="margin-bottom: 0.5rem">
      <div class="level-left">
        <div class="level-item">
          <h1 class="is-size-6 has-text-weight-semibold">{{label}}</h1>
          <b-tooltip :label="tooltip" v-if="tooltip" :multilined="true" :animated="true" type="is-warning">
            <span class="icon has-text-info">
              <i class="fas fa-info-circle"></i>
            </span>
          </b-tooltip>
        </div>
      </div>
    </div>
    <b-field class="group">
      <b-radio-button class="full-width" :name="name" v-model="data" :native-value="optionA" v-on:input="update()">
        <slot name="option-a">A</slot>
      </b-radio-button>
      <b-radio-button class="full-width" :name="name" v-model="data" :native-value="optionB" v-on:input="update()">
        <slot name="option-b">B</slot>
      </b-radio-button>
      <b-radio-button class="full-width" :name="name" v-model="data" :native-value="optionC" v-on:input="update()">
        <slot name="option-c">C</slot>
      </b-radio-button>
    </b-field>
  </div>
</template>

<script>
export default {
  props: [
    'name',
    'value',
    'option-a',
    'option-b',
    'option-c',
    'label',
    'tooltip'
  ],
  data() {
    return {
      data: this.value
    }
  },
  methods: {
    update: function() {
      this.$emit('input', this.data)
    }
  }
}
</script>

<style scoped>
.full-width {
  width: 100%;
}
.group {
  display: flex;
}
</style>
<style>
.b-radio.radio.button {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/inputs/RvTriRadio.vue